const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

const parseResponse = async (res) => {
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const payload = await res.json();
      detail = payload?.detail || detail;
    } catch (_e) {
      // ignore
    }
    throw new Error(detail);
  }
  return res.json();
};

const request = async (path) => {
  const response = await fetch(`${API_BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return parseResponse(response);
};

export const fetchExecutiveCommandCenterDashboard = (timeframe = 'today') =>
  request(`/api/executive/command-center?timeframe=${encodeURIComponent(timeframe)}`);

export const fetchExecutiveCommandCenterRecommendations = (timeframe = 'today') =>
  request(`/api/executive/command-center/recommendations?timeframe=${encodeURIComponent(timeframe)}`);
